import { buildManagePageQueryString } from "./helpers/buildManagePageQueryString";
import { jumboMediaAPI } from "./service";

export const translationsAPI = jumboMediaAPI.injectEndpoints({
    endpoints: (build) => ({
        getTranslations: build.query({
            query: (body: any) => ({
                url: `/api/Translations/DataTablesSource${buildManagePageQueryString(body.columns, body.page, body.searchTerm, (body.page - 1) * body.limit, body.limit, body.orderColumnIndex, body.isDescSortDir)}`,

            }),
            providesTags: ["Translations"],
        }),
        deleteTranslation: build.mutation({
            query: (body) => ({
                url: `/api/Translations/AdminDelete/${body.id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ["Translations"],
        }),
        createTranslation: build.mutation({
            query: (body) => ({
                url: `/api/Translations/AdminPost`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ["Translations"],
        }),
        updateTranslation: build.mutation({
            query: (body) => {
                return {
                    url: `/api/Translations/AdminPut/${body.Id}`,
                    method: 'PUT',
                    body,
                }
            },
            invalidatesTags: ["Translations"],
        }),
        getTranslationsByLang: build.query({
            query: (body: any) => ({
                url: `/api/Translations/UserGetTranslations?lang=${body.lang || 'en'}`,
            }),
        }),
        getUpdatedTranslations: build.query({
            query: (body: any) => ({
                url: `/api/Translations/UserCheckForTranslations?lastUpdateDate=${body.lastUpdateDate}&lang=${body.lang || 'en'}`,
            }),
        }),
    }),
});

export const {
    useGetTranslationsQuery,
    useDeleteTranslationMutation,
    useCreateTranslationMutation,
    useUpdateTranslationMutation,
    useGetTranslationsByLangQuery,
    useGetUpdatedTranslationsQuery,
    useLazyGetTranslationsByLangQuery,
    useLazyGetUpdatedTranslationsQuery,
    useLazyGetTranslationsQuery,
} = translationsAPI;